import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import alertHelper from '@/helpers/alert'

const state = {
  allTasks: [],
  selectedTaskInDetails: {},
}

const getters = {
  getAllTasks: state => state.allTasks,
  getSelectedTask: state => state.selectedTaskInDetails,
}

const mutations = {
  setAllTasks(state, data) {
    Vue.set(state, 'allTasks', data)
  },
  setSelectedTask(state, details) {
    Vue.set(state, 'selectedTaskInDetails', details)
  },
}

const actions = {
  async fetchAll({ commit }, { houseId, title, status }) {
    try {
      const params = {
        house_id: houseId,
        title,
        status
      }
      const response = await axios.get(`${config.apiBaseUrl}task/find`, { params })
      if (response.data.errno === 0) {
        const tasks = response.data.data;
        commit('setAllTasks', tasks)
      } else {
        throw new Error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },

  async fetchSelected({ getters, commit }, taskId ) {
    if (!taskId) {
      commit('setSelectedTask', null)
      return;
    }
    try {
      let response = await axios.get(`${config.apiBaseUrl}task/getDetails?task_id=${taskId}`)
      if (response.data.errno === 0) {
        const taskDetails = response.data.data
        let response2 = await axios.get(`${config.apiBaseUrl}task/getResult?task_id=${taskId}`)
        const jsonResult = response2.data.data.jsonResult
        taskDetails.jsonResult = jsonResult
        commit('setSelectedTask', taskDetails)
        console.log({getSelectedTask: getters['getSelectedTask']})
      } else {
        throw new Error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error)
      commit('setSelectedTask', null)
      console.log({setSelectedTask_error: error})
    }
  },

  async generateReport({ getters, dispatch }, auto_issue) {
    try {
      let task = getters['getSelectedTask'];
      let task_id = task.id;
      let response = await axios.post(`${config.apiBaseUrl}task/generateReport`, {
        task_id,
        auto_issue
      })
      if (response.data.errno === 0) {
        const responseData = response.data.data
        console.log('task/generateReport', { responseData })
        if (responseData.status === 'ERROR') {
          throw new Error(responseData.statusText)
        }

        let countDown = 40;
        const loopCheck = setInterval(() => {
          dispatch('fetchSelected', task_id)
          let reportURL = getters['getSelectedTask'].reportURL;
          console.log({generateReport: reportURL})
          if (reportURL) {
            clearInterval(loopCheck);
          }
          countDown --;
          if (countDown === 0) {
            clearInterval(loopCheck);
            console.log("Failed to get report URL after 2 minutes");
            throw new Error("Failed to get report URL after 2 minutes")
          }
        }, 3000)

        alertHelper.success('Please wait for a few seconds to prepare report for you.')
      } else {
        throw new Error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },

  async uploadReport({ getters, dispatch }, formData) {
    try {
      const task = getters['getSelectedTask'];
      const task_id = task.id;
      const response = await axios.post(`${config.apiBaseUrl}task/uploadReport`,
        formData
      )
      if (response.data.errno === 0) {
        console.log('task/uploadReport', { responseData: response.data.data })
        dispatch('fetchSelected', task_id)
        alertHelper.success('Report successfully uploaded.')
      } else {
        throw new Error(response.data.errmsg)
      }
  } catch (error) {
      alertHelper.error(error)
    }
  },

  async sendReport({ getters, dispatch }) {
    try {
      // console.log('Task.sendReport');
      const task = getters['getSelectedTask'];
      const task_id = task.id;
        const response = await axios.post(`${config.apiBaseUrl}task/sendReport`, { task_id })
        if (response.data.errno === 0) {
          dispatch('fetchSelected', task_id)
          alertHelper.success('Report email has been sent successfully.')
        } else {
          throw new Error(response.data.errmsg)
        }
    } catch (error) {
      // console.log('Task.sendReport', error);
      alertHelper.error(error)
    }
  },

}

const storeModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default storeModule
